import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GradingRule } from '../../../../shared/interface/grading-rule.interface';
import { AlertService } from '../../../../shared/services/alert.service';
import { CrudPromiseService } from '../../../../shared/services/crud-promise.service';

@Injectable({
    providedIn: 'root'
})
export class GradingRuleService extends CrudPromiseService<GradingRule>{

    constructor(protected http: HttpClient, protected alert: AlertService) {
        super(http, 'gradingRule', alert);
    }

    toggleIsEnabled(id: number): Observable<any> {
        return this.http.get(`/api/${this.apiUrl}/${id}/toggleIsEnabled`);
    }
}
